// extracted by mini-css-extract-plugin
export default {"statusSwitch":"StatusSwitch_statusSwitch__6sM0C","statusSwitchButton":"StatusSwitch_statusSwitchButton__hzvpJ","statusSwitchButtonOpen":"StatusSwitch_statusSwitchButtonOpen__cj-se"};